module.exports = __webpack_public_path__ + "static/hip-flash-new-4-d678a3f2908c86c902b28d5b5e1c0589.jpg";